import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../actions/workflowactions'
import CustomNotificationModal from '../../../components/CustomNotificationModal'
import * as appUtilityFunction from '../../../infrastructure/apputilityfunctions'
import * as constants from '../constants'

export default function WorkFlow() {

    const state = useSelector(state => state.workFlowReducer)
    const dispatch = useDispatch();

    function onRequestClose() {
        dispatch(actions.closeReport());
    }
    let approvalDetails = state.approvalDetails;
    let canShowApprovalProccess = false;
    if (approvalDetails) {
        if (approvalDetails.canPerformAction === true) {
            canShowApprovalProccess = true;
        }
    }
    const handleInputChanges = (e) => {
        let { name, value } = e.target;
        dispatch(actions.handleInputChange({ name, value }));
    }
    function excecuteProccessAction (approvalAction) {
        dispatch(actions.excecuteProccessAction(approvalAction)).then(resp=>{
            dispatch(actions.getNotifications());
            onRequestClose();
        })
    }
    let remarks = <textarea className='form-control'
        rows="5"
        id="remarks"
        name='remarks'
        placeholder='Please enter remarks'
        onChange={(e) => handleInputChanges(e)}
        value={state.remarks}
    />
    return (
        <CustomNotificationModal isOpen={state.showWorkFlow} onRequestClose={onRequestClose}
            modalTitle={state.workFlowOptions && state.workFlowOptions.workFlowTitle}>

            {canShowApprovalProccess &&
                <>

                    <div class="mb-3">
                        <h4><p> {approvalDetails && approvalDetails.description} </p> </h4>
                        <hr />
                        <label for="remarks" class="form-label">Remarks</label>
                        {remarks}
                    </div>
                    <div class="btn-group mb-2">
                        <button type="button" class="btn btn-success" onClick={() => excecuteProccessAction(constants.ApprovalAction_Approve)}>Approve</button>
                        <button type="button" class="btn btn-warning" onClick={() => excecuteProccessAction(constants.ApprovalAction_Reject)}>Reject</button>
                        {approvalDetails && approvalDetails.canCancelProcess &&
                            <button type="button" class="btn btn-danger" onClick={() => excecuteProccessAction(constants.ApprovalAction_Reject)}>Cancel</button>
                        }
                    </div>
                </>
            }

            <hr />
            <div class="mb-3">
                <h4>Approval History</h4>
                <hr />
                <table class="table table-centered mb-0">
                    <thead class="table-dark">
                        <tr>
                            <th>Approve</th>
                            <th>Status</th>
                            <th>Remarks</th>
                            <th>Actions</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {approvalDetails && approvalDetails.logs.map((log, index) => (
                            <tr key={index}>
                                <td>{log.approve}</td>
                                <td><span class={appUtilityFunction.getWorkFlowStatusBadge(log.Status)}>{log.statusText}</span></td>
                                <td><span class="badge bg-danger">{log.remarks}</span></td>
                                <td>{log.action}</td>
                                <td><span class="badge bg-dark">{appUtilityFunction.formatDate(log.date)}</span></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </CustomNotificationModal>
    );
}
